import { InjectionKey } from 'vue';

export const InjectionKeys = Object.freeze({
  SetFormDirty: Symbol('SetFormDirty') as InjectionKey<() => void>,
  FormSubmit: Symbol('FormSubmit') as InjectionKey<() => Promise<(() => void) | void>>,
  FormCancel: Symbol('FormCancel') as InjectionKey<() => void>
});
